import React from "react";
import PiBooleanProperty from "../../components/PiProperties/PiBooleanProperty";
import PiNumberProperty from "../../components/PiProperties/PiNumberProperty";
import PiColorPickerField from "../../components/PiColorPickerField";
import {
  InteractionProperty,
  InteractionPropertyType,
} from "../../models/InteractionProperty";

const isRgbaColor = (
  value: unknown,
): value is { r: number; g: number; b: number; a: number } => {
  if (typeof value !== "object" || value === null) return false;
  const color = value as { r?: unknown; g?: unknown; b?: unknown; a?: unknown };
  return (
    typeof color.r === "number" &&
    typeof color.g === "number" &&
    typeof color.b === "number" &&
    typeof color.a === "number"
  );
};

export default function InteractionPropertyView(props: {
  interactionProperty: InteractionProperty;
  onChange: (interactionProperty: InteractionProperty) => void;
}) {
  const interactionProperty = props.interactionProperty;
  
  const preview = () => {
    if (interactionProperty.type === InteractionPropertyType.boolean) {
      return <PiBooleanProperty interactionProperty={interactionProperty} onChange={props.onChange} />;
    } else if (interactionProperty.type === InteractionPropertyType.number) {
      return <PiNumberProperty interactionProperty={interactionProperty} onChange={props.onChange} />;
    } else if (interactionProperty.type === InteractionPropertyType.color) {
      return (
        <PiColorPickerField
          label={interactionProperty.name}
          color={
            isRgbaColor(interactionProperty.value)
              ? interactionProperty.value
              : { r: 255, g: 255, b: 255, a: 1 }
          }
          onChange={(color) =>
            props.onChange({ ...interactionProperty, value: color })
          }
        />
      );
    } else if (interactionProperty.type === InteractionPropertyType.text) {
      return <div>string</div>;
    } else {
      return <div>unknown</div>;
    }
  };
  return <>{preview()}</>;
}
